import script from "./SnackbarsMixin.vue?vue&type=script&lang=js"
export * from "./SnackbarsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__